import styled from 'styled-components';
import Image from 'react-bootstrap/Image';
import { COLORS } from 'modules/core/theme/colors';

export const AfgMessage = styled.div`
  font-size: 12px;
  color: ${COLORS.GREY_3};
  font-style: italic;
  text-align: right;
  font-weight: 500;
  margin-top: 2px;
`;

export const AfgLogo = styled(Image)`
  width: auto;
  max-height: 21px;
`;

export const BalloonFieldsContainer = styled.div<{ isPrintView: boolean }>`
  margin-bottom: 24px;
`;

export const BalloonFieldWrapper = styled.div`
  background-color: ${COLORS.GREY_30};
  border: 2px solid ${COLORS.GREY_3}80;
  border-radius: 5px;
  padding: 5px 7px;
`;

export const BalloonToggleContainer = styled.div<{ isAvailable: boolean }>`
  display: flex;
  align-items: center;
  column-gap: 8px;
  margin-left: auto;

  ${({ isAvailable }) => !isAvailable && `opacity: 70%;`}

  span {
    margin: 0 4px;
    font-size: 12px;
    font-weight: 500;
  }

  .react-toggle--checked .react-toggle-track,
  .react-toggle--checked:hover .react-toggle-track {
    background-color: ${COLORS.GREEN_8};
  }
`;
